import React from "react";
import { Box } from "@mui/material";

const NoticeBox = ({ bulletPoints }) => {
    return (
        <Box sx={{ width: "100%", mt: 2 }}>
            <span style={{ fontSize: "14px", fontWeight: "500" }}>Note*</span>
            <ul style={{ fontSize: "12px", margin: "0.5rem 0 0", paddingLeft: "1.25rem" }}>
                {bulletPoints.map((point, idx) => (
                    <li key={idx}>{point}</li>
                ))}
            </ul>
        </Box>
    );
};

export default NoticeBox;
